import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { WorkerService } from 'src/app/data/worker.service';
import { SnackBarService } from '../services/snack-bar.service';
import { WorkerProfileAccessService } from 'src/app/data/worker-profile-access.service';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SelfGuard {
  private workerService = inject(WorkerService);
  private snackbar = inject(SnackBarService);
  private workerProfileAccessService = inject(WorkerProfileAccessService);
  private authService = inject(AuthService);

  constructor() { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const matchAll = state.url.match(/\d+/g);
    const workerId = +matchAll[0];

    return this.workerService.getWorkerIdByAuthServerUserId(this.authService.authServerUserId).pipe(
      first(),
      map(id => workerId === id),
      tap(isLoggedUserProfile => this.workerProfileAccessService.setIsLoggedUserProfile(isLoggedUserProfile)),
      map(isLoggedUserProfile => !isLoggedUserProfile)
    );
  }
}
